import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import { 
  LineChartOutlined, 
  PieChartOutlined, 
  RiseOutlined,
  DollarOutlined,
  FileTextOutlined,
  UserOutlined
} from '@ant-design/icons';

const StatisticsPage = () => {
  return (
    <div style={{ padding: '24px' }}>
      <h1>数据统计</h1>
      
      <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
        <Col xs={24} sm={8}>
          <Card>
            <Statistic
              title="总交易额"
              value={2345678}
              precision={2}
              valueStyle={{ color: '#3f8600' }}
              prefix={<DollarOutlined />}
              suffix="元"
            />
          </Card>
        </Col>
        <Col xs={24} sm={8}>
          <Card>
            <Statistic
              title="债权总数"
              value={1234}
              valueStyle={{ color: '#1890ff' }}
              prefix={<FileTextOutlined />}
              suffix="笔"
            />
          </Card>
        </Col>
        <Col xs={24} sm={8}>
          <Card>
            <Statistic
              title="用户总数"
              value={5678}
              valueStyle={{ color: '#722ed1' }}
              prefix={<UserOutlined />}
              suffix="人"
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} lg={8}>
          <Card>
            <div style={{ textAlign: 'center' }}>
              <LineChartOutlined style={{ fontSize: '48px', color: '#1890ff', marginBottom: '16px' }} />
              <h3>交易统计</h3>
              <p>查看详细的交易数据分析</p>
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={8}>
          <Card>
            <div style={{ textAlign: 'center' }}>
              <PieChartOutlined style={{ fontSize: '48px', color: '#52c41a', marginBottom: '16px' }} />
              <h3>收益分析</h3>
              <p>分析投资收益和风险分布</p>
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={8}>
          <Card>
            <div style={{ textAlign: 'center' }}>
              <RiseOutlined style={{ fontSize: '48px', color: '#faad14', marginBottom: '16px' }} />
              <h3>市场趋势</h3>
              <p>了解市场动态和发展趋势</p>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default StatisticsPage;